<template>
  <PortalBlock :portal-block="2"></PortalBlock>
</template>

<script>
import PortalBlock from "./components/PortalBlock.vue";

export default {
  name: "portal-project",
  components: {
    PortalBlock,
  },
};
</script>
